import {Log} from './shared/log';

const log = Log.getLogger('app.component');

import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, NavigationStart, Router} from '@angular/router';
import {AuthService} from './services/auth/auth.service';
import {WindowRef} from './services/window-ref/window.ref';
import {AppConfig} from './app.config';
import {AuthTokenService} from './services/auth/auth-token.service';
import {FeatureToggles} from './shared/feature-toggles';
import {Angulartics2GoogleTagManager} from 'angulartics2/gtm';
import {Observable} from 'rxjs/Observable';
import {Idle} from 'idlejs/dist';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/timer';

declare const $: any;

@Component({
  selector: 'app-root',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  public _idToken: string;
  public _accessToken: string;
  public _expiresAt: number;
  public _prefetchTime: number;

  refreshSubscription: any;
  loading = false;
  loadingText = 'Loading...';
  isiOS: boolean;
  shouldDisplayAccountMenu = false;
  sessionExpired = false;

  constructor(
    private appConfig: AppConfig,
    private authService: AuthService,
    private angulartics2GoogleTagManager: Angulartics2GoogleTagManager,
    private router: Router,
    private route: ActivatedRoute,
    private windowRef: WindowRef,
    private authTokenService: AuthTokenService,
    private featureToggles: FeatureToggles
  ) {
    this._idToken = '';
    this._accessToken = '';
    this._expiresAt = 0;
    this._prefetchTime = parseFloat(localStorage.getItem('expiry')) - 100;
    const userAgent = typeof navigator === 'object' ? navigator.userAgent : '';
    this.isiOS = userAgent.match(/(iPad|iPhone|iPod)/g) ? true : false;
  }

  ngOnInit(): void {

    this.showPageLoading(true);

    this.router.events
      .subscribe((event) => {
        // check for a reload event (from Seniors Concessions)
        if (this.reloadIsNecessary(event)) {
          return this.authService.login(1, false);
        }
      });
    const loggedIn = this.authService.isLoggedIn();

    if (Boolean(sessionStorage.getItem('inactive_session')) === true) {
        this.authService.logout();
        return;
    }

    this.loadingText = 'Checking login status...';


    if (!loggedIn) {
      this.loadingText = 'Redirecting...';
      this.redirectToIntroPage();
      return;
    }


    if (this.windowRef.location.pathname === '/') {
      this.router.navigate(['widgets/recommended']);

    }

    // ensure token refresh works on page refreshes even if not on root.
    const idle = new Idle()
      .whenNotInteractive()
      .within(17000) // 28 min idle
      .do(() => {
        this.refreshSubscription.unsubscribe();
        sessionStorage.setItem('inactive_session', 'true');
        localStorage.setItem('access_token', '');
        this.sessionExpired = true;
      })
      .start();

    const expiresAt = (this._prefetchTime * 1000) + Date.now() - 60; // ensure expires is 60 seconds before
    this._accessToken = localStorage.getItem('access_token');
    this._expiresAt = expiresAt;
    this.scheduleRenewal();
    this.onPageReady();
  }

  public isAuthenticated(): boolean {
    // return this.authService.getAuthObj().authenticated;
    return this._accessToken && Date.now() < this._expiresAt;
  }

  public logout() {
    this.authService.logout();
  }

  public renewTokens(): void {
    console.log('renewTokens');
    this.authService.renewTokens(this);
  };

  public scheduleRenewal() {
    console.log('scheduleRenewal');
    if (!this.isAuthenticated()) {
      return;
    }
    this.unscheduleRenewal();

    const expiresAt = this._expiresAt;

    const source = Observable.of(expiresAt).flatMap(
      eAt => {
        const now = Date.now();
        return Observable.timer(Math.max(1, eAt - now));
      });

    this.refreshSubscription = source.subscribe(() => {
      this.renewTokens();
      this.scheduleRenewal();
    });
  }

  public unscheduleRenewal() {
    console.log('unscheduleRenewal');
    if (!this.refreshSubscription) {
      return;
    }
    this.refreshSubscription.unsubscribe();
  }


  private setAccountMenuDisplay() {
    // Fix to always display account menu until profile widget detects login/logout events
    this.shouldDisplayAccountMenu = !this.loading;
  }

  private redirectToIntroPage() {
    this.windowRef.navigateTo(this.windowRef.location.protocol + '//' + this.windowRef.location.host + '/intro/index.html');
  }

  private reloadIsNecessary(event) {
    return event instanceof NavigationStart && event.url === '/reload';
  }

  private onPageReady(): void {
    this.showPageLoading(false);

    setTimeout(() => {
      this.initialiseGTM();
      this.handleGoogleTagManagerScripts();
      this.authTokenService.monitorForTokenChange();
    }, 50);
  }

  private showPageLoading(loading: boolean): void {
    this.loading = loading;
    const sweTemplateElements = $('.qg-swe-template');

    if (loading) {
      sweTemplateElements.addClass('hidden');
    } else {
      sweTemplateElements.removeClass('hidden');
    }

    this.setAccountMenuDisplay();
  }

  private handleGoogleTagManagerScripts(): void {
    // Google Tag Manger loads scripts with duplicate IDs - this should fix that.
    const scripts = document.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++) {
      const s = scripts[i];
      if (s.hasAttribute('i')) {
        s.id = 'script_' + i;
      }
    }
  }

  private initialiseGTM(): void {
    const w = window;
    const d = document;
    const s = 'script';
    const l = 'dataLayer';
    const i = this.appConfig.getValue('gtm');

    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });

    const f = d.getElementsByTagName(s)[0],
      j = <HTMLScriptElement>d.createElement(s),
      dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src =
      '//www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  }
}




// WEBPACK FOOTER //
// ./app/app.component.ts